export default function toAgeLabel(birthdate, t, long = false) {
    if (!birthdate) return "—";
    if (!t) return "—";
    const b = new Date(birthdate);
    const now = new Date();
    let y = now.getFullYear() - b.getFullYear();
    let m = now.getMonth() - b.getMonth();
    if (m < 0) { y -= 1; m += 12; }

    if (long) {
        if (y <= 0 && m <= 0) return t('pets.age_format.months', { count: 0 });
        if (y <= 0) return t('pets.age_format.months', { count: m });
        if (m <= 0) return t('pets.age_format.years', { count: y });
        return t('pets.age_format.years_and_months', {
            years: t('pets.age_format.years', { count: y }),
            months: t('pets.age_format.months', { count: m })
        });
    } else {
        if (y <= 0 && m <= 0) return t('pets.age_format.months_short', { count: 0 });
        if (y <= 0) return t('pets.age_format.months_short', { count: m });
        if (m <= 0) return t('pets.age_format.years_short', { count: y });
        return t('pets.age_format.years_and_months_short', {
            years: t('pets.age_format.years_short', { count: y }),
            months: t('pets.age_format.months_short', { count: m })
        });
    }
}

export const fmtDateTime = (iso, t, lng = 'en') => {
    if (!iso) return "";
    if (!t) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";

    const parseOffsetMinutes = (s) => {
        if (/[Zz]$/.test(s)) return 0;
        const offsetMatch = s.match(/([+-])(\d{2}):?(\d{2})$/);
        if (!offsetMatch) return -new Date().getTimezoneOffset();
        const sign = offsetMatch[1] === "-" ? -1 : 1;
        return sign * (parseInt(offsetMatch[2], 10) * 60 + parseInt(offsetMatch[3], 10));
    };

    const offsetMin = parseOffsetMinutes(iso);
    const MS_DAY = 86_400_000;
    const now = new Date();

    const dayIndex = (timeObj) => Math.floor((timeObj.getTime() + offsetMin * 60000) / MS_DAY);
    const diffDays = dayIndex(d) - dayIndex(now);

    const timeStr = d.toLocaleTimeString(lng, { hour: "2-digit", minute: "2-digit" });

    if (diffDays === -1) return t('common.time.yesterday_at', { time: timeStr });
    if (diffDays === 0) return t('common.time.today_at', { time: timeStr });
    if (diffDays === 1) return t('common.time.tomorrow_at', { time: timeStr });

    const weekdayStr = d.toLocaleDateString(lng, { weekday: "long" });
    return t('common.time.weekday_at', { weekday: weekdayStr, time: timeStr });
};

export function getTimeAgo(dateStr, t, i18n) {
    if (!dateStr) return '';
    try {
        const date = new Date(dateStr);
        const now = new Date();
        const diffInSeconds = Math.floor((now - date) / 1000);
        if (diffInSeconds < 60) return t('common.time.just_now', 'Just now');
        
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        if (diffInMinutes < 60) return t('common.time.m_ago', { count: diffInMinutes, defaultValue: `${diffInMinutes}m ago` });
        
        const diffInHours = Math.floor(diffInMinutes / 60);
        if (diffInHours < 24) return t('common.time.h_ago', { count: diffInHours, defaultValue: `${diffInHours}h ago` });
        
        const diffInDays = Math.floor(diffInHours / 24);
        if (diffInDays < 7) return t('common.time.d_ago', { count: diffInDays, defaultValue: `${diffInDays}d ago` });
        
        const lng = i18n?.language || 'ru';
        return date.toLocaleDateString(lng, { month: 'short', day: 'numeric' });
    } catch (e) {
        return '';
    }
}